// Errores Api
export const SHOW_ERRORS_API = "SHOW_ERRORS_API";
// Auth
export const REGISTRO_EXITOSO = "REGISTRO_EXITOSO";
export const OBTENER_USUARIO = "OBTENER_USUARIO";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_EXITOSO = "LOGIN_EXITOSO";
export const CERRAR_SESION = "CERRAR_SESION";

export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_ALL_CLIENTS = "GET_ALL_CLIENTS";
export const GET_ALL_USERS_FISICOS = "GET_ALL_USERS_FISICOS";
export const GET_ALL_USERS_MORALES = "GET_ALL_USERS_MORALES";
export const ADD_USERS = "ADD_USERS";
export const UPDATE_USERS = "UPDATE_USERS";
export const DELETE_USERS = "DELETE_USERS";
export const GET_USER_ME = "GET_USER_ME";
export const USER_CHANGEPASSWORD = "USER_CHANGEPASSWORD";
export const UPDATE_INFO = "UPDATE_INFO";

export const GET_ALL_CURSOS = "GET_ALL_CURSOS";
export const ADD_CURSOS = "ADD_CURSOS";
export const UPDATE_CURSOS = "UPDATE_CURSOS";
export const DELETE_CURSOS = "DELETE_CURSOS";

export const GET_ALL_CURSOS_PUBLICOS = "GET_ALL_CURSOS_PUBLICOS";

export const GET_ALL_CATEGORIAS = "GET_ALL_CATEGORIAS";
export const ADD_CATEGORIAS = "ADD_CATEGORIAS";
export const UPDATE_CATEGORIAS = "UPDATE_CATEGORIAS";
export const DELETE_CATEGORIAS = "DELETE_CATEGORIAS";

export const GET_ALL_MODELOS = "GET_ALL_MODELOS";
export const ADD_MODELOS = "ADD_MODELOS";
export const UPDATE_MODELOS = "UPDATE_MODELOS";
export const DELETE_MODELOS = "DELETE_MODELOS";

export const GET_ALL_AGENDAS = "GET_ALL_AGENDAS";
export const GET_ALL_AGENDAS_COUNT = "GET_ALL_AGENDAS_COUNT";
export const ADD_AGENDAS = "ADD_AGENDAS";
export const UPDATE_AGENDAS = "UPDATE_AGENDAS";
export const DELETE_AGENDAS = "DELETE_AGENDAS";

export const ADD_INSTRUCTOR = "ADD_INSTRUCTOR";
export const ACCEPT_AGENDATION = "ACCEPT_AGENDATION";
export const CANCELED_AGENDATION = "CANCELED_AGENDATION";
export const CLASS_DONE = "CLASS_DONE";
export const RESCHEDULE = "RESCHEDULE";

export const GET_ALL_CURSOS_FAVORITOS = "GET_ALL_CURSOS_FAVORITOS";
export const ADD_CURSO_FAVORITO = "ADD_CURSO_FAVORITO";
export const DELETE_CURSO_FAVORITO = "DELETE_CURSO_FAVORITO";

export const GET_COUNT_CATEGORIAS = "GET_COUNT_CATEGORIAS";
export const GET_COUNT_COURSE = "GET_COUNT_COURSE";
export const GET_COUNT_RESERVATION = "GET_COUNT_RESERVATION";
export const GET_COUNT_MODELS = "GET_COUNT_MODELS";

export const GET_ALL_CALENDARIO = "GET_ALL_CALENDARIO";

export const DELETE_CURSOS_IMG = "DELETE_CURSOS_IMG";

export const GET_ALL_SEGMENTS = "GET_ALL_SEGMENTS";
export const ADD_SEGMENTS = "ADD_SEGMENTS";
export const UPDATE_SEGMENTS = "UPDATE_SEGMENTS";
export const DELETE_SEGMENTS = "DELETE_SEGMENTS";



